import { render, staticRenderFns } from "./TransactionData.vue?vue&type=template&id=4231ca5a&scoped=true&"
import script from "./TransactionData.vue?vue&type=script&lang=js&"
export * from "./TransactionData.vue?vue&type=script&lang=js&"
import style0 from "./TransactionData.vue?vue&type=style&index=0&id=4231ca5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231ca5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
